import { Box, Typography, Skeleton } from '@mui/material';
import { ContainedButton } from 'components/ContainedButton';
import { OptionButton } from 'components/OptionButton';
import React, { FC } from 'react';
import { Loan } from 'v2-types/order';

import { ModalData } from '../../types';
import { useStyles } from './styles';
import { TFunction } from 'i18next';

type Props = {
  loans: Loan[];
  isDataLoading: boolean;
  selectedLoan?: Loan;
  setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
  onSelectLoan: (loan: Loan | undefined, keepDirtyValues?: boolean) => void;
  t: TFunction;
};

export const Header: FC<Props> = ({
  loans,
  isDataLoading,
  selectedLoan,
  setModalData,
  onSelectLoan,
  t,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.headerTitle}>
      <Typography className={classes.title}>{t('loan:loans')}</Typography>

      <Box className={classes.pillsRow}>
        <Box className={classes.pillsScroll}>
          {isDataLoading &&
            [1, 2, 3].map((key) => (
              <Skeleton key={key} animation="wave" variant="text" height={42} width={86} />
            ))}
          {loans.map((loan, index) => (
            <OptionButton
              key={loan._id}
              isSelected={selectedLoan?._id === loan._id}
              text={loan.loan_number ? `${t('loan:loan')} #${loan.loan_number}` : `${t('loan:loan-unknown')}`}
              onClick={() => onSelectLoan(loan)}
            />
          ))}
        </Box>
        <Box className={classes.addButton}>
          <ContainedButton
            text={t('common:add')}
            icon="plus"
            disabled={isDataLoading}
            onClick={() => setModalData({ modal: 'createLoan' })}
          />
        </Box>
      </Box>
    </Box>
  );
};
